/**
 * Copyright ©2025 Drivepoint
 */

import {type DP_ERRORS_CODES, ERROR_DEFINITIONS} from "./DPErrorDefinition";

export type ErrorContext = {
  tab?: string;
};

export type ErrorAction = {
  label: string;
  onClick: (...args: any[]) => void;
};

export class DPError extends Error {
  public code: DP_ERRORS_CODES | (string & {});
  public context?: ErrorContext;
  public action?: ErrorAction;

  constructor(code: DP_ERRORS_CODES | (string & {}), context?: ErrorContext, action?: ErrorAction) {
    super(code);
    this.code = code;
    this.context = context;
    this.action = action;
  }

  static isDPError(error: any): error is DPError {
    return error?.code && error.code in ERROR_DEFINITIONS;
  }

}